import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';

const ThemeContext = createContext(null);

const STORAGE_KEY = 'predmarket.theme';

// Initial theme: localStorage > 'dark'. Dark (das blaue Theme) ist der
// Marken-Default fuer neue Besucher -- die System-Einstellung wird
// bewusst NICHT mehr beruecksichtigt, damit jeder Erstbesuch im
// gewuenschten Look startet. Nur eine explizite Nutzer-Wahl ueber den
// Toggle (in localStorage) ueberschreibt das.
// WICHTIG: Muss mit dem Inline-Skript in public/index.html
// uebereinstimmen (gleicher STORAGE_KEY, gleicher Default), sonst FOUC.
const readInitialTheme = () => {
  if (typeof window === 'undefined') return 'dark';
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === 'light' || stored === 'dark') return stored;
  } catch { /* localStorage gesperrt */ }
  return 'dark';
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(readInitialTheme);

  // Apply theme to <html> -- Tailwind darkMode='class' liest .dark vom
  // documentElement, nicht von body. Persistiert in localStorage damit
  // Reload nicht den Toggle vergisst.
  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'dark') root.classList.add('dark');
    else root.classList.remove('dark');
    try { window.localStorage.setItem(STORAGE_KEY, theme); } catch { /* ignore */ }
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((t) => (t === 'dark' ? 'light' : 'dark'));
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, isDark: theme === 'dark' }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
};

export default ThemeContext;
